module.exports = __webpack_public_path__ + "static/media/15.37c58ad0.png";